import React, { FC } from 'react';

type Props = {
  children?: React.ReactNode;
};

/**
 * An h2, not the h3 this used to be.
 *
 * These are the first headings under the page's own h1 on any page whose content has no
 * h2 of its own — every single-card institutional page — so an h3 there skips a level and
 * breaks the outline a screen-reader user navigates by. h2 is the honest level for a
 * top-level footer group, and nothing visual moves with it: Tailwind's preflight resets
 * every heading to inherit its font-size and weight, so the size comes from this class
 * either way.
 */
const LinkGroupHeader: FC<Props> = ({ children }) => {
  return <h2 className="text-slate-200 font-semibold mb-2">{children}</h2>;
};

export default LinkGroupHeader;
